export default "__VITE_ASSET__BIOHYWRD__"